module.exports = __webpack_public_path__ + "img/drawing.97d170df.jpg";